import {Container, Title, Content} from "./styles"
export const Topic = ({ title, content }) => {
  return (
    <Container>
      <Title variant="h1">{title}</Title>
      <Content variant="body2">{content}</Content>
    </Container>
  )
}